"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncStateInfo = void 0;
// vendors
const react_1 = require("react");
// types
const useAsyncStateInfo_types_1 = require("./types/useAsyncStateInfo.types");
const to = (promise) => promise.then((data) => ({ data, error: null })).catch((error) => ({ error, data: null }));
const isAuthorizationRequired = (errorInfo) => errorInfo?.httpStatus === useAsyncStateInfo_types_1.HttpStatus.FORBIDDEN &&
    errorInfo?.responseHeaders?.[useAsyncStateInfo_types_1.ResponseHeaders.X_SECURITY] === useAsyncStateInfo_types_1.XSecurityHeaders.AUTHORIZATION_REQUIRED;
const INITIAL_STATE = {
    status: useAsyncStateInfo_types_1.AsyncStateInfoStatusType.INITIAL,
    error: null,
    data: null,
};
const useAsyncStateInfo = (asyncFn) => {
    const [{ status, error, data }, setState] = (0, react_1.useState)(INITIAL_STATE);
    const reset = (0, react_1.useCallback)(() => {
        setState(INITIAL_STATE);
    }, []);
    (0, react_1.useEffect)(() => {
        reset();
    }, [asyncFn]);
    const call = (0, react_1.useCallback)(async (...args) => {
        setState(prevState => ({ ...prevState, status: useAsyncStateInfo_types_1.AsyncStateInfoStatusType.LOADING }));
        const { error: err, data: res } = await to(asyncFn(...args));
        let newStatus;
        if (err && isAuthorizationRequired(err)) {
            newStatus = useAsyncStateInfo_types_1.AsyncStateInfoStatusType.AUTHORIZATION_REQUIRED;
        }
        else if (err) {
            newStatus = useAsyncStateInfo_types_1.AsyncStateInfoStatusType.ERROR;
        }
        else if (res) {
            newStatus = useAsyncStateInfo_types_1.AsyncStateInfoStatusType.SUCCESS;
        }
        setState(prevState => ({ ...prevState, data: res, error: err, status: newStatus }));
        return { error: err, data: res };
    }, []);
    return {
        call,
        data,
        error,
        reset,
        isAuthorizationRequired: status === useAsyncStateInfo_types_1.AsyncStateInfoStatusType.AUTHORIZATION_REQUIRED,
        isError: status === useAsyncStateInfo_types_1.AsyncStateInfoStatusType.ERROR,
        isLoading: status === useAsyncStateInfo_types_1.AsyncStateInfoStatusType.LOADING,
        isSuccess: status === useAsyncStateInfo_types_1.AsyncStateInfoStatusType.SUCCESS,
    };
};
exports.useAsyncStateInfo = useAsyncStateInfo;
//# sourceMappingURL=useAsyncStateInfo.js.map